import store from "../store";

export default async function is_admins({next, router}) {
    await store.dispatch('profile/role');
    await store.dispatch('profile/me');
    let role = await store.getters['profile/role'];
    let user = await store.getters['profile/me'](Math.floor(Math.random() * 1000000));

    if (user && user.email === 'senior-retoucher03@retoucher.app') {
        return router.push({name: "User Profile"});
    }

    if ((role !== 'admin') && (role !== 'senior-retoucher')) {
        return router.push({name: "User Profile"});
    }

    return next();
}
